import React from "react";
import { CloseCircleFilled } from '@ant-design/icons';

const CrossIcon: React.FC = () => {
    return <CloseCircleFilled size={24} style={{color: "#ddd"}} />;
};
export default(CrossIcon);